module.exports = __webpack_public_path__ + "img/heart.141b0b04.svg";